import { render } from "./scan-card.vue?vue&type=template&id=d0fbf2ce"
import script from "./scan-card.vue?vue&type=script&lang=ts"
export * from "./scan-card.vue?vue&type=script&lang=ts"
script.render = render

export default script